import React from "react";
import "./BackButton.css";

const BackButton = ({ onClick, disabled = false, ariaLabel = "Back", className = "" }) => (
  <button
    type="button"
    className={`shared-back-btn ${className}`.trim()}
    onClick={onClick}
    disabled={disabled}
    aria-label={ariaLabel}
  >
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="19" y1="12" x2="5" y2="12" />
      <polyline points="12 19 5 12 12 5" />
    </svg>
  </button>
);

export default BackButton;
